import HeaderTitleContent from "../../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SingleMinigrid from "../../../../features/minigrid/components/SingleMinigrid";
import styles from "./SingleMinigridPage.module.scss";
export default function SingleMinigridPage() {
  return (
    <>
      <HeaderTitleContent withGoBackBtn goBackBtnLabel="Tous les minigirds"   >
        <SingleMinigrid.Title />
      </HeaderTitleContent>

      <div className={styles["global-container"]}>
        <div>
          <SingleMinigrid.LiveDashboard />
        </div>
        <div className={styles["row"]}>
          <div className={styles["col"]}>
            <SingleMinigrid.Description />
          </div>
          <div className={[styles["col"], styles["col--btn"]].join(" ")}>
            <SingleMinigrid.MetersLink />
            <SingleMinigrid.LuminairesLink />
            <SingleMinigrid.PlanBTLink />
            <SingleMinigrid.EditBtn />
            <SingleMinigrid.DeleteBtn  backTo="/main/minigrid"/>
          </div>

        </div>
        <div className={[styles["row"], styles["row--1"]].join(" ")}>
          <div className={styles["col"]}>
            <SingleMinigrid.GalleryImage />
          </div>
          <div className={[styles["col"], styles["col--location"]].join(" ")}>
            <SingleMinigrid.LocationMap />
          </div>
        </div>
        <div>
          <SingleMinigrid.PowerInfo />
        </div>
      </div>
    </>
  );
}
